import { fabric } from 'fabric';

export class PricingObject {
  public additionalPrice: number;
  public width: number;
  public height: number;
  public charCount: number;
  public colorChanges: number;
  public colorCount: number;
  public type: 'text' | 'shape';
  public referencedObject: fabric.Object;
}
